const { mainConfigService, applePayConfigService, walletConfigService } = require('./services/config');
const { getFriendPayConfig } = require('./utils/friendPayUtils');
const {
  elements,
  logoSvg,
  method,
  SDK_FOPS,
  WALLETS_SVG,
} = require('./variables');
const {
  html,
  htmlModals,
  saveCardBlock,
  saveCards,
  paymentMethodBlock,
  paymentMethod,
  friendPayMethod,
  buttonPay,
  buttonApple,
  cardRemoveModal,
  clickToPayContainer,
  failedModal,
  iframeLoader,
  applePayNotSupportedHtml,
  feesHtml,
  totalAmountHtml,
  buttonStc,
  saveCardCheckbox,
  successModal,
  redirectModal,
  buttonUrPay,
  mobilePayModal,
  mobilePayOTPModal,
  tamaraPaymentMethod,
  abaPaymentMethod,
  installmentsNotAvailable,
  tamaraWidget,
  loadingInstallmentsOptions,
  tabbyWidget,
  talyWidget,
  buttonCancel,
  rejectTransactionModal,
  alertModal,
  walletPaymentMethod,
} = require('./html');
const {
  requiredKeys,
  keysToValidate,
  googleButtonTypes,
  appleButtonTypes,
  gooleButtonSizeMode,
  googleButtonColors,
  appleButtonColors,
  googleButtonLocale,
  globalLanguageCodes,
} = require('./fields');
const { safeBillingStringify } = require('./utils/billing');
const { $t } = require('./translate');
const { CARDS_SVG, CLICK_TO_PAY_PRELOAD_FLOWS, LANGUAGES, WALLET_NAMES } = require('./constants');
const { escapeHtml, sanitizeApiData, coerceToBoolean, sanitizeUrl, sanitizeTheme, sanitizeCssProperty } = require('./security');
const { _applePayAvailable, loadApplePayJS, embedPlaceHolderApplePayButton } = require('./apple');

const ccvValidation = (cardCcv) => {
  const data = {};
  const errors = {};
  let error = false;

  if (cardCcv) {
    data.cvv = cardCcv;
  } else {
    errors.tokenCardCcvBlock = $t('This field is required');
    error = true;
  }

  return {
    data: data,
    errors: errors,
    error: error,
  };
};

const phoneNumberSetSpace = (phoneNumber) => {
  if (phoneNumber.length > 3 && phoneNumber.length <= 6) {
    return phoneNumber.slice(0, 3) + ' ' + phoneNumber.slice(3);
  } else if (phoneNumber.length > 6) {
    return (
      phoneNumber.slice(0, 3) +
      ' ' +
      phoneNumber.slice(3, 6) +
      ' ' +
      phoneNumber.slice(6)
    );
  } else {
    return phoneNumber;
  }
};

const getSaveCardsHtml = (cards, currencyCodeDefault, paymentMethods, paymentServices) => {
  let html = '';
  if (cards && cards.length) {
    for (let key = 0; key < cards.length; key++) {
      const card = cards[key];
      let currencyCode = currencyCodeDefault;
      let amount = '';
      let fee = '';
      let description = '';
      let billing = '';
      if (paymentMethods || paymentServices) {
        const m = paymentMethods.find(({ code }) => code == card.pg_code) || paymentServices.find(({ code }) => code == card.pg_code) ;
        if (m) {
          currencyCode = m.currency_code;
          fee = m.fee;
          amount = m.amount;
          description = m.fee_description;
          billing = m.billing;
        }
      }
      let expiry = '';
      if (card.is_expired) {
        if (card.expiry_month && card.expiry_year) {
          expiry =
            $t('Expired on') + ' ' + card.expiry_month + '/' + card.expiry_year;
        } else {
          expiry = $t('Expired');
        }
      } else {
        expiry =
          $t('Exp') + ' ' + card.expiry_month + '/' + card.expiry_year;
      }

      const expiryClass = card.is_expired ? 'ottu__sdk-red' : '';
      // Generate mobile-friendly card number format (* 1234 instead of **** 1234)
      const numberMobile = card.number ? card.number.replace(/\*+\s*/g, '* ').trim() : card.number;
      html += saveCards(card.cvv_required)
        .replace(/{%key%}/g, key)
        .replace(/{%logo%}/g, CARDS_SVG[(card.brand || '').toUpperCase()] || '')
        .replace(/{%brand%}/g, card.brand)
        .replace(/{%gateway%}/g, card.pg)
        .replace(/{%alt%}/g, card.brand)
        .replace(/{%url%}/g, card.submit_url)
        .replace(/{%token%}/g, card.token)
        .replace(/{%number%}/g, card.number)
        .replace(/{%numberMobile%}/g, numberMobile)
        .replace(/{%expiry%}/g, expiry)
        .replace(/{%expiryClass%}/g, expiryClass)
        .replace(/{%isExpired%}/g, card.is_expired)
        .replace(/{%radioClass%}/g, elements.accordionItemRadio)
        .replace(/{%ccvClass%}/g, card.cvv_required ? 'cvv_required' : '')
        .replace(/{%ccv_required%}/g, card.cvv_required)
        .replace(/{%is_preferred%}/g, card.is_preferred)
        .replace(/{%delete_url%}/g, card.delete_url)
        .replace(/{%fee%}/g, fee)
        .replace(/{%description%}/g, description || '')
        .replace(/{%currency_code%}/g, currencyCode)
        .replace(/{%amount%}/g, amount)
        .replace(/{%currency_code_default%}/g, currencyCodeDefault)
        .replace(/{%billing%}/g, safeBillingStringify(billing))
        .replace(/{%pg_code%}/g, card.pg_code || '')
        .replace(/{%expiry_month%}/g, card.expiry_month || '')
        .replace(/{%expiry_year%}/g, card.expiry_year || '')
        .replace(/{%bin%}/g, card.bin || '');
    }
  }

  const saveCard = saveCardBlock().replace(/{%content%}/g, html);
  return saveCard;
};

const getPaymentMethodsHtml = (
  paymentMethods = [],
  saveCard,
  currency_code,
  flexMethods = []
) => {
  let html = '';

  if (paymentMethods.length || flexMethods.length) {
    let key = 0;

    for (let index = 0; index < paymentMethods.length; key++, index++) {
      const method = paymentMethods[index];
      let canSaveCard;
      if (typeof saveCard == 'boolean') {
        canSaveCard = saveCard;
      } else if (typeof saveCard == 'undefined') {
        canSaveCard = method.can_save_card ? method.can_save_card : false;
      }

      if (
        (method.flow === SDK_FOPS.OTTU_PG && checkFormsofPayments('ottuPG')) ||
        (method.flow === SDK_FOPS.REDIRECT && checkFormsofPayments('redirect'))
      ) {
        const hasOneIcon = (method.pg_icons?.length ?? 0) <= 1;
        const showIframe = method.flow === SDK_FOPS.OTTU_PG && method.use_as_jazz_sdk === true && checkFormsofPayments('jazz');

        html += paymentMethod(hasOneIcon, method, showIframe)
            .replace(/{%savecard%}/g, canSaveCard && !window.redirectSubmitUrl)
            .replace(/{%key%}/g, key)
            .replace(/{%submit_url%}/g, method.submit_url)
            .replace(/{%redirect_url%}/g, method.redirect_url)
            .replace(/{%payment_url%}/g, method.payment_url)
            .replace(/{%cancel_url%}/g, '')
            .replace(/{%flow%}/g, method.flow)
            .replace(/{%code%}/g, method.code)
            .replace(/{%name%}/g, method.name)
            .replace(/{%fee%}/g, method.fee)
            .replace(/{%description%}/g, method.fee_description || '')
            .replace(/{%method_description%}/g, method.description || '')
            .replace(/{%currency_code%}/g, method.currency_code)
            .replace(/{%amount%}/g, method.amount)
            .replace(/{%currency_code_default%}/g, currency_code)
            .replace(/{%direct_payment_url%}/g, method.direct_payment_url)
            .replace(/{%trandata%}/g, method.trandata || '')
            .replace(/{%method_type%}/g, 'payment_method')
            .replace(/{%billing%}/g, safeBillingStringify(method.billing))
            .replace(/{%use_as_jazz_sdk%}/g, method.use_as_jazz_sdk || false);
      }
    }

    for (let index = 0; index < flexMethods.length; key++, index++) {
      const method = flexMethods[index];

      if (!method.pre_payment_options_available && !CLICK_TO_PAY_PRELOAD_FLOWS.includes(method.flow)) {
        html += loadingInstallmentsOptions()
          .replace(/{%key%}/g, key)
          .replace(/{%fee%}/g, method.fee)
          .replace(/{%flow%}/g, method.flow)
          .replace(/{%code%}/g, method.code)
          .replace(/{%cancel_url%}/g, '')
          .replace(/{%amount%}/g, method.amount)
          .replace(/{%savecard%}/g, method.can_save_card)
          .replace(/{%submit_url%}/g, method.submit_url)
          .replace(/{%redirect_url%}/g, method.redirect_url)
          .replace(/{%payment_url%}/g, method.payment_url)
          .replace(/{%description%}/g, method.fee_description || '')
          .replace(/{%method_description%}/g, method.description || '')
          .replace(/{%currency_code%}/g, method.currency_code)
          .replace(/{%currency_code_default%}/g, currency_code)
          .replace(/{%method_type%}/g, 'flex_method')
          .replace(/{%billing%}/g, safeBillingStringify(method.billing));
        continue;
      }
      if (method.flow === 'aba_payway') {
        if (method.sub_options && method.sub_options.length > 0) {
          method.sub_options.forEach((subOpt, index) => {
            const name = subOpt.title || subOpt.label || `Option ${index + 1}`;
            const icon = subOpt.icons?.svg || subOpt.icons?.webp || method.icon || '';
            const description = subOpt.description || '';

            html += abaPaymentMethod(name, icon, description)
              .replace(/{%key%}/g, `${key}-${index}`)
              .replace(/{%flow%}/g, method.flow)
              .replace(/{%code%}/g, method.code)
              .replace(/{%fee%}/g, method.fee)
              .replace(/{%submit_url%}/g, `${method.submit_url}`)
              .replace(/{%description%}/g, method.fee_description || '')
              .replace(/{%method_description%}/g, method.description || '')
              .replace(/{%currency_code%}/g, method.currency_code)
              .replace(/{%amount%}/g, method.amount)
              .replace(/{%currency_code_default%}/g, currency_code)
              .replace(/{%sub_option_value%}/g, subOpt.value)
              .replace(/{%method_type%}/g, 'flex_method')
              .replace(/{%billing%}/g, safeBillingStringify(method.billing));

          });
        }
      }
      if (['csuc', 'doku', 'geidea'].includes(method.flow)) {
        const hasOneIcon = (method.pg_icons?.length ?? 0) <= 1;
        html += paymentMethod(hasOneIcon, method)
          .replace(/{%key%}/g, key)
          .replace(/{%submit_url%}/g, method.submit_url)
          .replace(/{%flow%}/g, method.flow)
          .replace(/{%code%}/g, method.code)
          .replace(/{%name%}/g, method.name)
          .replace(/{%fee%}/g, method.fee)
          .replace(/{%description%}/g, method.fee_description || '')
          .replace(/{%method_description%}/g, method.description || '')
          .replace(/{%currency_code%}/g, method.currency_code)
          .replace(/{%amount%}/g, method.amount)
          .replace(/{%currency_code_default%}/g, currency_code)
          .replace(/{%method_type%}/g, 'flex_method')
          .replace(/{%billing%}/g, safeBillingStringify(method.billing));
      }

      // Generic BNPL method handler (tamara, tabby, taly)
      const bnplMethods = {
        [SDK_FOPS.TAMARA]: {
          getTemplate: (name, method) => tamaraPaymentMethod(name, method.amount),
          getLabel: (method) => getInstallmentMethodLabels(method.pre_payment_options),
          replacements: ['key', 'flow', 'code', 'fee', 'submit_url', 'description', 'method_description', 'currency_code', 'amount', 'currency_code_default', 'method_type', 'billing']
        },
        [SDK_FOPS.TABBY]: {
          getTemplate: () => paymentMethod(true, method),
          getLabel: () => $t('Pay in 4 interest-free payments'),
          replacements: ['key', 'fee', 'flow', 'code', 'name', 'logo', 'cancel_url', 'amount', 'savecard', 'submit_url', 'redirect_url', 'payment_url', 'description', 'method_description', 'currency_code', 'currency_code_default', 'method_type', 'billing']
        },
        [SDK_FOPS.TALY]: {
          getTemplate: () => paymentMethod(true, method),
          getLabel: () => $t('Split your payment with Taly'),
          replacements: ['key', 'fee', 'flow', 'code', 'name', 'logo', 'cancel_url', 'amount', 'savecard', 'submit_url', 'redirect_url', 'payment_url', 'description', 'method_description', 'currency_code', 'currency_code_default', 'method_type', 'billing']
        }
      };

      const bnplConfig = bnplMethods[method.flow];
      if (bnplConfig) {
        const isAvailable = method.pre_payment_options?.is_available;

        if (isAvailable) {
          const name = bnplConfig.getLabel(method);
          let template = bnplConfig.getTemplate(name, method);

          // Common replacements mapping
          const replacementsMap = {
            key: key,
            flow: method.flow,
            code: method.code,
            fee: method.fee,
            submit_url: method.submit_url,
            description: method.fee_description || '',
            method_description: method.description || '',
            currency_code: method.currency_code,
            amount: method.amount,
            currency_code_default: currency_code,
            method_type: 'flex_method',
            billing: safeBillingStringify(method.billing),
            name: name,
            logo: method.icon,
            cancel_url: '',
            savecard: method.can_save_card,
            redirect_url: method.redirect_url,
            payment_url: method.payment_url
          };

          // Apply replacements
          bnplConfig.replacements.forEach(key => {
            template = template.replace(new RegExp(`{%${key}%}`, 'g'), replacementsMap[key]);
          });

          html += template;
        } else {
          html += installmentsNotAvailable(method.icon, method.flow);
        }
      }
    }
  }

  // Inject Friend Pay if allowed in formsOfPayment
  if (checkFormsofPayments('friendPay')) {
    // Use utility function to get friend pay configuration
    const { billing, shareText } = getFriendPayConfig();

    // Static description text using translation
    const staticDescription = $t("We'll create a link so someone else can pay for your order.");

    // Create synthetic Friend Pay method from setupPreload data
    const friendPayMethod_data = {
      flow: SDK_FOPS.FRIEND_PAY,
      code: 'friend_pay',
      name: shareText,  // Use shareText as the payment method name
      amount: billing.amount?.value || '0.00',
      currency_code: billing.amount?.currency_code || currency_code || 'USD',
      fee: billing.fee?.value || '0.000',
      fee_description: staticDescription,  // Use static description
      submit_url: '',
      redirect_url: '',
      billing: billing
    };

    const key = paymentMethods.length + flexMethods.length;

    html += friendPayMethod(friendPayMethod_data)
      .replace(/{%savecard%}/g, false)
      .replace(/{%key%}/g, key)
      .replace(/{%submit_url%}/g, '')
      .replace(/{%redirect_url%}/g, '')
      .replace(/{%flow%}/g, SDK_FOPS.FRIEND_PAY)
      .replace(/{%code%}/g, 'friend_pay')
      .replace(/{%name%}/g, shareText)
      .replace(/{%fee%}/g, friendPayMethod_data.fee)
      .replace(/{%description%}/g, staticDescription)
      .replace(/{%currency_code%}/g, friendPayMethod_data.currency_code)
      .replace(/{%amount%}/g, friendPayMethod_data.amount)
      .replace(/{%currency_code_default%}/g, currency_code)
      .replace(/{%method_type%}/g, 'payment_method')
      .replace(/{%billing%}/g, safeBillingStringify(billing));
  }

  const paymentMethodhtml = html
    ? paymentMethodBlock().replace(/{%content%}/g, html)
    : html;
  return paymentMethodhtml;
};

const sortPaymentServices = (paymentServices = []) => {
  const digitalWalletFlows = [
    SDK_FOPS.APPLE_PAY,
    SDK_FOPS.GOOGLE_PAY,
    SDK_FOPS.SAMSUNG_PAY,
    SDK_FOPS.STC_PAY,
    SDK_FOPS.UR_PAY,
  ];

  return [...paymentServices].sort((a, b) => {
    const aIsDigitalWallet = digitalWalletFlows.includes(a.flow);
    const bIsDigitalWallet = digitalWalletFlows.includes(b.flow);
    const aIsBalanceWallet = a.flow === SDK_FOPS.WALLET;
    const bIsBalanceWallet = b.flow === SDK_FOPS.WALLET;

    // Digital wallets first
    if (aIsDigitalWallet && !bIsDigitalWallet) return -1;
    if (!aIsDigitalWallet && bIsDigitalWallet) return 1;
    if (aIsDigitalWallet && bIsDigitalWallet) {
      const flowComparison = (a.flow || '').localeCompare(b.flow || '');
      if (flowComparison !== 0) return flowComparison;
      return (a.label || '').localeCompare(b.label || '');
    }

    // Balance wallets second
    if (aIsBalanceWallet && !bIsBalanceWallet) return -1;
    if (!aIsBalanceWallet && bIsBalanceWallet) return 1;
    if (aIsBalanceWallet && bIsBalanceWallet) {
      return (a.label || '').localeCompare(b.label || '');
    }

    // Others alphabetical
    return (a.label || '').localeCompare(b.label || '');
  });
};

const getPaymentServicesHtml = async (paymentServices = [], hasPaymentMethods = false, hasFlexMethods = false, currency_code) => {
  let html = '';
  
  if ((hasPaymentMethods || hasFlexMethods || paymentServices.length > 1)) {
    let key = 0;
    const sortedServices = sortPaymentServices(paymentServices);
    if (paymentServices.some(method => method.flow === SDK_FOPS.APPLE_PAY) ) {
      try {
        const { appleScriptLoaded } = await loadApplePayJS();
        if (!appleScriptLoaded) {
          embedPlaceHolderApplePayButton();
        }
        applePayConfigService.updateConfig({ isApplePaySDKAvailable: !appleScriptLoaded });
      } catch (error) {
        console.log('Apple Pay SDK failed to load, using fallback:', error);
        applePayConfigService.updateConfig({ isApplePaySDKAvailable: false });
      }
    }

    for (let index = 0; index < sortedServices.length; key++, index++) {
      const method = sortedServices[index];
      if (
        (method.flow === SDK_FOPS.APPLE_PAY && checkFormsofPayments('applePay')) && _applePayAvailable() ||
        (method.flow === SDK_FOPS.GOOGLE_PAY && checkFormsofPayments('googlePay')) ||
        (method.flow === SDK_FOPS.STC_PAY && checkFormsofPayments('stcPay')) ||
        (method.flow === SDK_FOPS.UR_PAY && checkFormsofPayments('urPay')) ||
        (method.flow === SDK_FOPS.SAMSUNG_PAY && checkFormsofPayments('samsungPay'))
      ) {
        const hasOneIcon = true;
        const amountValue = method.amount ?? method.total_price;
        const iconUrl = method.icon || WALLETS_SVG[method.flow] || '';

        // Create a new object with the icon since the original method object is frozen
        const parsedMethod = Object.assign({}, method, { icon: iconUrl });

        html += paymentMethod(hasOneIcon, parsedMethod)
          .replace(/{%key%}/g, key)
          .replace(/{%submit_url%}/g, method.submit_url)
          .replace(/{%redirect_url%}/g, method.redirect_url)
          .replace(/{%payment_url%}/g, method.payment_url)
          .replace(/{%cancel_url%}/g, '')
          .replace(/{%flow%}/g, method.flow)
          .replace(/{%code%}/g, method.code)
          .replace(/{%name%}/g, method.label || WALLET_NAMES[method.flow] || 'Wallet')
          .replace(/{%fee%}/g, method.fee)
          .replace(/{%description%}/g, method.fee_description || '')
          .replace(/{%method_description%}/g, method.description || '')
          .replace(/{%currency_code%}/g, method.currency_code)
          .replace(/{%amount%}/g, amountValue)
          .replace(/{%currency_code_default%}/g, currency_code)
          .replace(/{%method_type%}/g, 'payment_service')
          .replace(/{%billing%}/g, safeBillingStringify(method.billing));
      }
    }
  }

  const paymentMethodhtml = html
    ? paymentMethodBlock().replace(/{%content%}/g, html)
    : html;
  return paymentMethodhtml;
};

const getWalletHtml = (paymentServices = [], defaultCurrencyCode) => {
  const wallets = paymentServices.filter(s => s.flow === SDK_FOPS.WALLET);
  if (!wallets.length) return '';

  const parts = [];
  wallets.forEach((walletService, index) => {
    const billing = walletService.billing;
    const balanceSource = billing && (billing.balance_before || billing.available_balance);
    if (!balanceSource) return;

    const availableBalance = balanceSource.display || '0';
    const currencyCode = balanceSource.currency_code || defaultCurrencyCode;

    const iconUrl = walletService.icon || WALLETS_SVG[walletService.flow] || '';
    const parsedMethod = Object.assign({}, walletService, { icon: iconUrl });

    const walletName = walletService.label || WALLET_NAMES[walletService.flow] || 'Wallet';

    const html = walletPaymentMethod(parsedMethod)
      .replace(/{%key%}/g, `wallet_${index}`)
      .replace(/{%code%}/g, escapeHtml(walletService.code || ''))
      .replace(/{%flow%}/g, walletService.flow)
      .replace(/{%name%}/g, walletName)
      .replace(/{%currency_code%}/g, currencyCode)
      .replace(/{%currency_code_default%}/g, defaultCurrencyCode)
      .replace(/{%available_balance%}/g, availableBalance)
      .replace(/{%billing%}/g, safeBillingStringify(billing));

    parts.push(html);
  });

  return parts.join('');
};

const getValidatedIframeData = (method) => {
  if (!method) return false;

  const {
    amount,
    currency_code,
    direct_payment_url,
    direct_save_card_url,
    trandata,
    enc_key_url,
    can_save_card,
    cvv_required,
    form_fields,
  } = method;

  return {
    amount,
    currency_code,
    direct_payment_url,
    direct_save_card_url,
    trandata,
    enc_key_url,
    can_save_card,
    cvv_required,
    form_fields: form_fields ? JSON.stringify(form_fields) : undefined,
  };
};


const getCardRemoveModalHtml = (number) => {
  return cardRemoveModal().replace(/{%number%}/g, number);
};

const getRejectModalHtml = () => {
  return rejectTransactionModal()
};

const getPopupModalHtml = (type, message, response) => {
  let html = '';
  if (response) {
    for (const key in response) {
      if (
        Object.prototype.hasOwnProperty.call(response, key) &&
        response[key]
      ) {
        html += `<p>${escapeHtml(key)} : ${escapeHtml(response[key])}</p>`;
      }
    }
  }
  const safeMessage = escapeHtml(message || '');

  if (type === 'success') {
    return successModal()
      .replace(/{%message%}/g, safeMessage)
      .replace(/{%response%}/g, html);
  } else if (type === 'error') {
    return failedModal()
      .replace(/{%message%}/g, safeMessage)
      .replace(/{%response%}/g, html);
  } else if (type === 'alert') {
    return alertModal().replace(/{%message%}/g, safeMessage);
  } else if (type === 'redirect') {
    return redirectModal().replace(/{%message%}/g, safeMessage);
  }
};

const getFailedModalHtml = (error, heading, buttonText) => {
  const safeError = escapeHtml(error || $t('Something Went Wrong'));
  const safeHeading = escapeHtml(heading);
  const safeButtonText = escapeHtml(buttonText);
  
  return failedModal(safeHeading, safeButtonText)
    .replace(/{%message%}/g, safeError)
    .replace(/{%response%}/g, '');
};

const getMobilePayModal = (mobileNo, canSaveCard, saveCard, type) => {
  if (mobileNo) {
    mobileNo = phoneNumberSetSpace(mobileNo);
  }
  const safeMobileNo = escapeHtml(mobileNo || '');
  
  return mobilePayModal(canSaveCard, saveCard, type).replace(
    /{%mobileNo%}/g,
    safeMobileNo
  );
};

const getTamaraWidget = (name, amount, description) => {
  const safeName = escapeHtml(name || '');
  const safeAmount = escapeHtml(amount || '');
  const safeDescription = escapeHtml(description || '');
  return tamaraWidget(safeName, safeAmount, safeDescription);
};

const getTabbyWidget = (name, logo, description) => {
  const safeName = escapeHtml(name || '');
  const safeLogo = sanitizeUrl(logo || '');
  const safeDescription = escapeHtml(description || '');
  return tabbyWidget(safeName, safeLogo, safeDescription);
};

const getTalyWidget = (name, logo, description) => {
  const safeName = escapeHtml(name || '');
  const safeLogo = sanitizeUrl(logo || '');
  const safeDescription = escapeHtml(description || '');
  return talyWidget(safeName, safeLogo, safeDescription);
};

const getMobilePayOTPModal = () => {
  return mobilePayOTPModal();
};

const getApplePayNotSupportedHtml = () => {
  return applePayNotSupportedHtml();
};

const getApplePayHtml = (applePay, isWalletActive) => {
  if (applePay) {
    return buttonApple(isWalletActive);
  }
};

const getWalletButtonsHtml = (method) => {
  let button;
  if (method && method.flow == SDK_FOPS.STC_PAY) {
    button = buttonStc();
  } else if (method && method.flow == SDK_FOPS.UR_PAY) {
    button = buttonUrPay();
  }

  const iconUrl = sanitizeUrl(method.icon || '') || CARDS_SVG[method.flow.toUpperCase()] || '';

  return button
    .replace(/{%icon%}/g, iconUrl)
    .replace(/{%savecard%}/g, method.can_save_card)
    .replace(/{%submit_url%}/g, method.submit_url)
    .replace(/{%payment_url%}/g, method.payment_url)
    .replace(/{%flow%}/g, method.flow)
    .replace(/{%code%}/g, method.code)
    .replace(/{%name%}/g, method.name)
    .replace(/{%fee%}/g, method.fee)
    .replace(/{%description%}/g, method.fee_description || '')
    .replace(/{%method_description%}/g, method.description || '')
    .replace(/{%currency_code%}/g, method.currency_code)
    .replace(/{%amount%}/g, method.amount);
};

const getSaveCardCheckbox = (canSaveCard, disabled) => {
  if (canSaveCard === 'true' || canSaveCard === true) {
    return saveCardCheckbox(disabled);
  }

  return '';
};

const getFeesHtml = () => {
  return feesHtml();
};

const getTotalAmountHtml = () => {
  return totalAmountHtml();
};

const getButtonsHtml = (cancel) => {
  let html = buttonPay(); 
  if (cancel) {
    html += buttonCancel(mainConfigService.get('rejectButtonConfig')?.renderAsLink);
  }
  return html;
};

const getClickToPayHtml = () => {
  return clickToPayContainer();
}

const getHtml = (displayMode) => {
  return html(displayMode);
};

const getHtmlErorrModal = () => {
  return htmlModals();
};

const getIframeLoader = () => {
  return iframeLoader();
};

const checkSaveCardsExist = (data) => {
  if (data && data.customer_id && data.cards && data.cards.length) {
    return true;
  } else {
    return false;
  }
};

const checkResponseStatus3ds = (response) => {
  if (
    response &&
    response.status == '3DS' &&
    (response.redirect_url ||
      (response.html && response.ws_url && response.reference_number))
  ) {
    return true;
  } else {
    return false;
  }
};

const checkResponseStatusSuccess = (response) => {
  if (response && response.status == 'success') {
    return true;
  } else {
    return false;
  }
};

const checkResponseStatusCanceled = (response) => {
  if (response && response.status == 'canceled') {
    return true;
  } else {
    return false;
  }
};

const checkResponseStatusError = (response) => {
  if (response && response.status == 'error') {
    return true;
  } else {
    return false;
  }
};

const checkResponseStatusFailed = (response) => {
  if (response && response.status == 'failed') {
    return true;
  } else {
    return false;
  }
};

const checkRender = (render) => {
  if (render) {
    return true;
  } else {
    return false;
  }
};

const setMethod = (
  type,
  code,
  submit_url,
  cancel_url,
  redirect_url,
  payment_url,
  id,
  ccv_required,
  can_save_card,
  amount,
  currency_code,
  pg,
  card_pg,
  direct_payment_url,
  trandata,
  sub_option_value,
  brand,
  number,
  expiry_month,
  expiry_year,
  bin,
) => {
  method.type = type;
  method.code = code;
  method.submit_url = submit_url;
  method.cancel_url = cancel_url ? cancel_url : '';
  method.redirect_url = redirect_url ? redirect_url : '';
  method.payment_url = payment_url ? payment_url : '';
  method.id = id ? id : '';
  method.ccv_required = ccv_required ? ccv_required : false;
  method.can_save_card = can_save_card ? can_save_card : false;
  method.amount = amount ? amount : '';
  method.currency_code = currency_code ? currency_code : '';
  method.pg = pg ? pg : '';
  method.direct_payment_url = direct_payment_url ? direct_payment_url : '';
  method.trandata = trandata ? trandata : '';
  method.card_pg = card_pg ? card_pg : '';
  method.sub_option_value = sub_option_value ? sub_option_value : '';
  method.brand = brand ? brand : '';
  method.number = number ? number : '';
  method.expiry_month = expiry_month ? expiry_month : '';
  method.expiry_year = expiry_year ? expiry_year : '';
  method.bin = bin ? bin : '';
  return true;
};

const validateMobilePayFields = (value, type) => {
  if (!value) {
    return false;
  } else if (value && type == 'phoneNo') {
    const phoneNoRegex = new RegExp(/^(?:\d{10}|\d{12})$/);
    return phoneNoRegex.test(value);
  } else if (value && type == 'otp') {
    const otpRegex = new RegExp(
      `^(?:\\D*\\d){${mainConfigService.get('mobilePayOtpLength') || 1}}\\D*$`
    );
    return otpRegex.test(value);
  }
};

const setEventListenerForRadioButtons = (elements) => {
  for (let i = 0; i < elements.length; i++) {
    if (!elements[i]) {
      continue;
    }

    elements[i].addEventListener('keydown', (e) => {
      if (e.which === 13) {
        elements[i].blur();
      }
    });

    elements[i].addEventListener('input', (e) => {
      let ccvLength = 4;
      const brandName = elements[i].attributes['data-brand']
        ? elements[i].attributes['data-brand'].value
        : '';

      if (brandName === 'AMEX') {
        ccvLength = 4;
      } else {
        ccvLength = 3;
      }

      const value = e.target.value.replace(/[^0-9]+/g, '').slice(0, ccvLength);

      e.target.value = value;
      elements[i].classList.remove('ottu__sdk-invalid-input');

      if (elements[i].closest('.ottu__sdk-invalid-input')) {
        elements[i]
          .closest('.ottu__sdk-invalid-input')
          .classList.remove('ottu__sdk-invalid-input');
      }
    });
  }
};

const resetAllSavedCards = (elements) => {
  elements.forEach((element) => {
    if (element.closest('.ottu__sdk-invalid-input')) {
      element
        .closest('.ottu__sdk-invalid-input')
        .classList.remove('ottu__sdk-invalid-input');
    }

    element.value = '';
  });
};

const resetSelectedCheckboxes = (elements, checkbox) => {
  if (elements) {
    elements.forEach((element) => {
      if (element !== checkbox) {
        if (element.checked) element.checked = false;
      }
    });
  }
};

const checkFormsofPayments = (form) => {
  if (mainConfigService.get('formsOfPayment') && mainConfigService.get('formsOfPayment').length)
    return mainConfigService.get('formsOfPayment').includes(form);
};

const replaceSdk = (selector) => {
  let oldCheckout = document.getElementById(selector);
  let newCheckout = document.createElement('div');
  newCheckout.setAttribute('id', selector);
  oldCheckout.parentElement.replaceChild(newCheckout, oldCheckout);
};

const getCssTheme = (theme) => {
  // Extract responsive breakpoints before sanitizing
  const { responsive, ...baseTheme } = theme;

  // Sanitize the theme using DOMPurify-based sanitization
  const sanitizedTheme = sanitizeTheme(baseTheme);

  const cssClasses = Object.entries(sanitizedTheme)
    .map(([className, properties]) => {
      const cssClassProperties = Object.entries(properties)
        .map(([property, value]) => `${property}: ${value} !important;`)
        .join('\n');
      return `.ottu__sdk-${className}-theme {
      ${cssClassProperties}
    }`;
    })
    .join('\n\n');

  // Generate responsive overrides using container queries
  // Responds to the SDK container width, not the viewport
  let responsiveCss = '';
  if (responsive && typeof responsive === 'object') {
    const breakpoints = Object.keys(responsive)
      .map(Number)
      .filter(bp => Number.isFinite(bp) && bp > 0)
      .sort((a, b) => b - a); // descending for correct max-width cascade

    if (breakpoints.length > 0) {
      responsiveCss += '\n.ottu__sdk-container { container-type: inline-size; }\n';
    }

    breakpoints.forEach(bp => {
      const bpTheme = sanitizeTheme(responsive[bp]);
      const bpRules = Object.entries(bpTheme)
        .map(([className, properties]) => {
          const props = Object.entries(properties)
            .map(([prop, val]) => `${prop}: ${val} !important;`)
            .join('\n');
          return `.ottu__sdk-${className}-theme { ${props} }`;
        })
        .join('\n');
      if (bpRules) {
        responsiveCss += `\n@container (max-width: ${bp}px) {\n${bpRules}\n}\n`;
      }
    });
  }

  let sheet = document.createElement('style');
  sheet.innerHTML = cssClasses + responsiveCss;
  sheet = handleOverridenStyles(sheet);
  return sheet;
};

const filterStyles = (theme, allowedProps) => {
  if (theme) {
    const allowedProperties = allowedProps;
    const filteredObject = {};

    for (const key in theme) {
      if (allowedProperties.includes(key)) {
        filteredObject[key] = theme[key];
      }
    }
    return filteredObject;
  } else {
    return {};
  }
};

const buildPseudoElementCss = (themeObj) => {
  const knobSafeProps = ['background-color', 'border-color', 'border-width', 'border-radius', 'height', 'width', 'box-shadow'];
  let css = '';
  for (const prop in themeObj) {
    if (knobSafeProps.includes(prop)) {
      const sanitized = sanitizeCssProperty(prop, themeObj[prop]);
      if (sanitized !== null) {
        css += `${prop}: ${sanitized} !important; `;
      }
    }
  }
  return css;
};

const handleOverridenStyles = (sheet) => {
  if (mainConfigService.get('theme')['selected-method']) {
    const selectedBg = mainConfigService.get('theme')['selected-method']['background-color'];
    const selectedBorder = mainConfigService.get('theme')['selected-method']['border-color'];
    sheet.innerHTML += `.ottu__sdk-accordion-item.ottu__sdk-border-green { background-color: ${selectedBg} !important; border-color: ${selectedBorder} !important; } input[type='radio']:checked + label { border-color: ${selectedBorder}; background-color: ${selectedBg} !important; } .ottu__sdk-card-iframe-wrapper.show { background-color: ${selectedBg} !important; border-color: ${selectedBorder} !important; }`;
  }
  if (mainConfigService.get('theme')['selected-checkbox']) {
    sheet.innerHTML += `input:checked + .slider { background-color: ${mainConfigService.get('theme')['selected-checkbox']['background-color']}; }`;
    sheet.innerHTML += `.ottu__sdk-wallet-loading .switch .slider:before { border-top-color: ${mainConfigService.get('theme')['selected-checkbox']['background-color']}; }`;
  }
  if (mainConfigService.get('theme')['checkbox-knob']) {
    sheet.innerHTML += `.slider:before { ${buildPseudoElementCss(mainConfigService.get('theme')['checkbox-knob'])} }`;
  }
  if (mainConfigService.get('theme')['selected-checkbox-knob']) {
    sheet.innerHTML += `input:checked + .slider:before { ${buildPseudoElementCss(mainConfigService.get('theme')['selected-checkbox-knob'])} }`;
  }
  return sheet;
};

const handleApplePayStyles = () => {
  if (applePayConfigService.get('isApplePaySDKAvailable')) {
    if (
      mainConfigService.get('theme')?.applePay?.buttonType &&
      validateWalletButtonType(mainConfigService.get('theme').applePay.buttonType, 'applePay')
    ) {
      applePayConfigService.updateConfig({ buttonType: mainConfigService.get('theme').applePay.buttonType });
    }
    if (
      mainConfigService.get('theme')?.applePay?.buttonColor &&
      validateWalletButtonColor(mainConfigService.get('theme').applePay.buttonColor, 'applePay')
    ) {
      applePayConfigService.updateConfig({ buttonColor: mainConfigService.get('theme').applePay.buttonColor });
    }
  } else {
    // Fallback to old CSS-based styling for the button element
    let sheet = document.createElement('style');
    if (
      mainConfigService.get('theme')?.applePay?.buttonType &&
      validateWalletButtonType(mainConfigService.get('theme').applePay.buttonType, 'applePay')
    ) {
      sheet.innerHTML = `.ottu__sdk-apple-pay-button-type {-apple-pay-button-type: ${
        mainConfigService.get('theme').applePay.buttonType || 'plain'
      }}`;
    }
    if (
      mainConfigService.get('theme')?.applePay?.buttonColor &&
      validateWalletButtonColor(mainConfigService.get('theme').applePay.buttonColor, 'applePay')
    ) {
      sheet.innerHTML += `.ottu__sdk-apple-pay-button-style {-apple-pay-button-style: ${
        mainConfigService.get('theme').applePay.buttonColor || 'black'
      }}`;
    }

    return sheet;
  }
};

const calculateSubTotal = (amount, fee) => {
  let subTotal = amount - fee;
  if (amount.includes('.')) {
    let decimalsDigits = amount.split('.')[1].length;
    return subTotal.toFixed(decimalsDigits);
  }
  return subTotal;
};

const validateSetupPreload = (preloadData) => {
  if (isObjectEmpty(preloadData)) {
    return false;
  }

  const validateObject = (obj, keys) => {
    for (const key of keys) {
      if (!(key in obj)) {
        return false;
      }
    }
    return true;
  };

  const validateArrayObjects = (val, keys) => {
    if (Array.isArray(val)) {
      for (const obj of val) {
        if (!validateObject(obj, keys)) {
          return false;
        }
      }
      return true;
    } else {
      if (!validateObject(val, keys)) {
        return false;
      }
      return true;
    }
  };

  const validatePaymentMethods = (methods, keys) => {
    if (!Array.isArray(methods)) {
      return false;
    }

    return methods.every((method) => {
      if (!validateObject(method, keys)) {
        return false;
      }

      if (method.flow === SDK_FOPS.OTTU_PG) {
        return !!method.redirect_url;
      } else if (
        method.flow === SDK_FOPS.STC_PAY ||
        method.flow === SDK_FOPS.UR_PAY
      ) {
        return !!method.payment_url && !!method.submit_url;
      } else {
        return !!method.submit_url;
      }
    });
  };

  const validatePaymentServices = (services) => {
    if (!Array.isArray(services)) {
      return false;
    }
    return services.every((service) => {
      if (service.flow == SDK_FOPS.GOOGLE_PAY) {
        return validateObject(service, keysToValidate['google_pay_config']);
      } else if (service.flow == SDK_FOPS.APPLE_PAY) {
        return validateObject(service, keysToValidate['apple_pay_config']);
      } else if (service.flow === SDK_FOPS.SAMSUNG_PAY) {
        return validateObject(service, keysToValidate['samsung_pay_config']);
      } else if (
        service.flow == SDK_FOPS.STC_PAY ||
        service.flow == SDK_FOPS.UR_PAY
      ) {
        return validateObject(service, [
          'payment_url',
          'submit_url',
          ...keysToValidate['payment_methods'],
        ]);
      } else if (service.flow === SDK_FOPS.WALLET) {
        return true;
      }

      return false;
    });
  };

  return requiredKeys.every((key) => {
    switch (key) {
      case 'cards':
      case 'google_pay_config':
      case 'apple_pay_config':
        return (
          !preloadData[key] ||
          Object.keys(preloadData[key]).length === 0 ||
          validateArrayObjects(preloadData[key], keysToValidate[key])
        );
      case 'apple_pay_available':
      case 'google_pay_available':
        return (
          !preloadData[key] ||
          preloadData[key] === true ||
          preloadData[key] === false
        );
      case 'payment_methods':
        return (
          preloadData[key] &&
          (preloadData[key].length === 0 ||
            validatePaymentMethods(preloadData[key], keysToValidate[key]))
        );
      case 'payment_services':
        return (
          !preloadData[key] ||
          preloadData[key].length === 0 ||
          validatePaymentServices(preloadData[key])
        );
      default:
        return Object.hasOwnProperty.call(preloadData, key);
    }
  });
};

const findPaymentConfig = (methods, methodFlow, methodName, methodCode) => {
  if (methods && (methodFlow || methodName || methodCode)) {
    return methods.find(({ flow, name, code }) => {
      return (
        (!methodFlow || (flow && flow.toLowerCase() === methodFlow.toLowerCase())) &&
        (!methodName || (name && name.toLowerCase() === methodName.toLowerCase())) &&
        (!methodCode || (code && code.toLowerCase() === methodCode.toLowerCase()))
      );
    });
  }
};

const handleMobilePayStyles = (type) => {
  let sheet = document.createElement('style');
  let cssContent = '';
  const bgColor = mainConfigService.get('theme')?.[type]?.['background-color'];
  if (bgColor) {
    const safeColor = sanitizeCssProperty('background-color', bgColor) || 'white';
    cssContent = `.ottu__sdk-${type}-theme { background-color: ${safeColor} !important}`;
  }
  
  sheet.innerHTML = cssContent;
  return sheet;
};

const validateWalletButtonType = (value, type) => {
  if (type === 'googlePay') {
    return googleButtonTypes.includes(value);
  }
  if (type === 'applePay') {
    return appleButtonTypes.includes(value);
  }
};

const validateWalletButtonColor = (value, type) => {
  if (type === 'googlePay') {
    return googleButtonColors.includes(value);
  }
  if (type === 'applePay') {
    return appleButtonColors.includes(value);
  }
};

const validateWalletButtonSizeMode = (value, type) => {
  if (type === 'googlePay') {
    return gooleButtonSizeMode.includes(value);
  }
};

const validateWalletButtonLocale = (value, type) => {
  if (type === 'googlePay') {
    return googleButtonLocale.includes(value);
  }
  if (type == 'applePay') {
    return globalLanguageCodes.includes(value);
  }
};

const isObjectEmpty = (object = {}) => {
  return Object.keys(object).length === 0 && object.constructor === Object;
};

const isOnlyApplePay = (data) => {
  const { payment_services, apple_pay_available, google_pay_available } = data;
  const applePayServices = payment_services?.filter(service => service.flow === SDK_FOPS.APPLE_PAY) || [];

  if (
    !google_pay_available &&
    ((payment_services?.length === 0 && apple_pay_available) ||
      (payment_services?.length  && payment_services?.length === applePayServices.length))
  ) {
    return true;
  }

  return false;
};

const getInstallmentMethodLabels = (configs, defaultName) => {
  if (!configs?.payment_labels?.length) {
    return defaultName;
  }

  const paymentLabel = configs.payment_labels[0];

  if (mainConfigService.get('lang') === LANGUAGES.EN) {
    return paymentLabel.description_en || defaultName;
  }

  if (mainConfigService.get('lang') === LANGUAGES.AR) {
    return paymentLabel.description_ar || defaultName;
  }
};

const loadCSS = (element) => {
  return new Promise((resolve, reject) => {
    const cssLink = document.createElement('link');
    cssLink.href = process.env.SERVER_URL + '/v3/css/checkout.css';
    cssLink.rel = 'stylesheet';
    cssLink.as = 'style';
    cssLink.onload = resolve;
    cssLink.onerror = reject;

    element.appendChild(cssLink);
  });
};

const loadExternalCSS = () => {
  return new Promise((resolve, reject) => {
    if (document.getElementById('ottu-external-css')) {
      resolve();
      return;
    }

    const cssLink = document.createElement('link');
    cssLink.id = 'ottu-external-css';
    cssLink.href = process.env.SERVER_URL + '/v3/css/checkout-external.css';
    cssLink.rel = 'stylesheet';
    cssLink.as = 'style';
    cssLink.onload = resolve;
    cssLink.onerror = reject;

    document.head.appendChild(cssLink);
  });
};

const generateSamsungOrderNo = (value) => {
  if (!value) {
    return ""
  }

  return value.slice(0, 36);
};

/**
 * Preloads and registers custom fonts using the FontFace API.
 *
 * @param {Array} fonts - An array of font definitions:
 *   {
 *     family: 'font-name',               // required
 *     src: 'url(...)',                   // required (can be full or relative)
 *     descriptors: { weight, style }     // optional
 *   }
 *
 * @returns {Promise} - Resolves when all fonts are loaded and added.
 */
function preloadFonts(fonts) {
  const fontPromises = fonts.map(({ family, src, descriptors = {} }) => {
    const fontFace = new FontFace(family, `url(${src})`, descriptors);
    return fontFace.load().then((loadedFace) => {
      document.fonts.add(loadedFace);
    }).catch((err) => {
      console.log(`Failed to load font "${family}":`, err);
    });
  });

  return Promise.all(fontPromises);
}

/**
 * Checks if a string appears to be a URL
 * @param {string} str - String to check
 * @returns {boolean} True if string looks like a URL
 */
const isUrl = (str) => {
  if (typeof str !== 'string' || str.length === 0) {
    return false;
  }

  // Check for absolute URLs using URL constructor
  try {
    new URL(str);
    return true;
  } catch {
    // Not an absolute URL, check for relative paths
    return str.startsWith('/') && str.length > 1;
  }
}

const handleWalletConfigs = (data) => {
  if (data.google_pay_config || data.apple_pay_config) {
    if (!data.payment_services) {
      data.payment_services = [];
    }
    
    if (
      data.google_pay_available &&
      data.google_pay_config &&
      !findPaymentConfig(data.payment_services, SDK_FOPS.GOOGLE_PAY)
    ) {
      data.payment_services.push({
        ...data.google_pay_config,
        flow: SDK_FOPS.GOOGLE_PAY,
      });
    }
    
    if (
      data.apple_pay_available &&
      data.apple_pay_config &&
      !findPaymentConfig(data.payment_services, SDK_FOPS.APPLE_PAY)
    ) {
      data.payment_services.push({
        ...data.apple_pay_config,
        flow: SDK_FOPS.APPLE_PAY,
      });
    }
  }

  if (data.payment_methods) {
    if (!data.payment_services) {
      data.payment_services = [];
    }

    const urPayConfig = findPaymentConfig(data.payment_methods, SDK_FOPS.UR_PAY);
    if (urPayConfig) {
      const urPayIndex = data.payment_methods.findIndex(method =>
        method.flow && method.flow.toLowerCase() === SDK_FOPS.UR_PAY
      );
      if (urPayIndex !== -1) {
        data.payment_methods.splice(urPayIndex, 1);
        data.payment_services.push(urPayConfig);
      }
    }

    const stcPayConfig = findPaymentConfig(data.payment_methods, SDK_FOPS.STC_PAY);
    if (stcPayConfig) {
      const stcPayIndex = data.payment_methods.findIndex(method =>
        method.flow && method.flow.toLowerCase() === SDK_FOPS.STC_PAY
      );
      if (stcPayIndex !== -1) {
        data.payment_methods.splice(stcPayIndex, 1);
        data.payment_services.push(stcPayConfig);
      }
    }
  }

  // Populate wallet config from raw data (before sanitization preserves pg_codes)
  if (data.payment_services) {
    data.payment_services
      .filter(s => s.flow === SDK_FOPS.WALLET)
      .forEach(w => walletConfigService.upsertWallet(w));
  }
};

function decodeJWT(jwt) {
  try {
    if (!jwt || typeof jwt !== 'string') {
      throw new Error('Invalid JWT: token must be a non-empty string');
    }

    // Split the JWT into its three parts: header, payload, signature
    const parts = jwt.split('.');
    if (parts.length !== 3) {
      throw new Error('Invalid JWT: token must have three parts separated by dots');
    }

    // Decode the payload (second part)
    const base64Payload = parts[1];

    // Replace URL-safe characters with standard Base64 characters
    const base64 = base64Payload.replace(/-/g, '+').replace(/_/g, '/');

    // Decode from Base64
    const jsonPayload = atob(base64);

    // Parse the JSON string into an object
    const payload = JSON.parse(jsonPayload);

    return payload;
  } catch (error) {
    console.error('Error decoding JWT:', error);
    throw new Error(`Failed to decode JWT: ${error.message}`);
  }
}

exports.decodeJWT = decodeJWT;

const sanitizePaymentData = (rawData) => {
  return {
    ...rawData,
    amount:
      typeof rawData.amount !== 'undefined'
        ? escapeHtml(rawData.amount)
        : undefined,
    currency_code:
      typeof rawData.currency_code !== 'undefined'
        ? escapeHtml(rawData.currency_code)
        : undefined,
    can_save_card:
      typeof rawData.can_save_card !== 'undefined'
        ? coerceToBoolean(rawData.can_save_card)
        : undefined,
    payment_methods: rawData.payment_methods?.map(sanitizeApiData) || [],
    cards: rawData.cards?.map(sanitizeApiData) || [],
    payment_services:
      rawData.payment_services?.map(sanitizeApiData) || [],
    flex_methods: rawData.flex_methods?.map(sanitizeApiData) || [],
  };
};

/**
 * Normalizes a config object by deeply converting it to a plain JavaScript object.
 * This handles Vue proxy objects, reactive objects, and any other wrapper objects
 * that may cause unintended side effects in the SDK flow.
 *
 * @param {*} obj - The object to normalize (can be any type)
 * @returns {*} A plain JavaScript version of the input
 */
const normalizeConfig = (obj) => {
  // Handle null and undefined
  if (obj === null || obj === undefined) {
    return obj;
  }

  // Handle primitive types
  if (typeof obj !== 'object') {
    return obj;
  }

  // Handle Date objects
  if (obj instanceof Date) {
    return new Date(obj.getTime());
  }

  // Handle Arrays
  if (Array.isArray(obj)) {
    return obj.map(item => normalizeConfig(item));
  }

  // Handle plain objects and proxies
  // This works for Vue proxies, regular objects, and other object wrappers
  const normalized = {};
  for (const key in obj) {
    // Only process own properties (skips prototype chain)
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      normalized[key] = normalizeConfig(obj[key]);
    }
  }

  return normalized;
};

exports.normalizeConfig = normalizeConfig;
exports.sanitizePaymentData = sanitizePaymentData;
exports.handleWalletConfigs = handleWalletConfigs;
exports.loadCSS = loadCSS;
exports.loadExternalCSS = loadExternalCSS;
exports.getInstallmentMethodLabels = getInstallmentMethodLabels;
exports.generateSamsungOrderNo = generateSamsungOrderNo;
exports.findPaymentConfig = findPaymentConfig;
exports.validateSetupPreload = validateSetupPreload;
exports.calculateSubTotal = calculateSubTotal;
exports.handleOverridenStyles = handleOverridenStyles;
exports.buildPseudoElementCss = buildPseudoElementCss;
exports.filterStyles = filterStyles;
exports.ccvValidation = ccvValidation;
exports.getHtml = getHtml;
exports.getApplePayNotSupportedHtml = getApplePayNotSupportedHtml;
exports.getSaveCardsHtml = getSaveCardsHtml;
exports.getPaymentMethodsHtml = getPaymentMethodsHtml;
exports.sortPaymentServices = sortPaymentServices;
exports.getPaymentServicesHtml = getPaymentServicesHtml;
exports.getWalletHtml = getWalletHtml;
exports.getCardRemoveModalHtml = getCardRemoveModalHtml;
exports.getRejectModalHtml = getRejectModalHtml;
exports.getPopupModalHtml = getPopupModalHtml;
exports.getButtonsHtml = getButtonsHtml;
exports.getApplePayHtml = getApplePayHtml;
exports.getIframeLoader = getIframeLoader;
exports.checkSaveCardsExist = checkSaveCardsExist;
exports.checkResponseStatus3ds = checkResponseStatus3ds;
exports.checkResponseStatusSuccess = checkResponseStatusSuccess;
exports.checkResponseStatusCanceled = checkResponseStatusCanceled;
exports.checkResponseStatusError = checkResponseStatusError;
exports.checkResponseStatusFailed = checkResponseStatusFailed;
exports.checkRender = checkRender;
exports.setMethod = setMethod;
exports.getHtmlErorrModal = getHtmlErorrModal;
exports.resetAllSavedCards = resetAllSavedCards;
exports.setEventListenerForRadioButtons = setEventListenerForRadioButtons;
exports.checkFormsofPayments = checkFormsofPayments;
exports.replaceSdk = replaceSdk;
exports.resetSelectedCheckboxes = resetSelectedCheckboxes;
exports.getMobilePayModal = getMobilePayModal;
exports.getMobilePayOTPModal = getMobilePayOTPModal;
exports.validateMobilePayFields = validateMobilePayFields;
exports.phoneNumberSetSpace = phoneNumberSetSpace;
exports.getSaveCardCheckbox = getSaveCardCheckbox;
exports.getFeesHtml = getFeesHtml;
exports.getTotalAmountHtml = getTotalAmountHtml;
exports.getCssTheme = getCssTheme;
exports.getWalletButtonsHtml = getWalletButtonsHtml;
exports.getFailedModalHtml = getFailedModalHtml;
exports.handleApplePayStyles = handleApplePayStyles;
exports.validateWalletButtonType = validateWalletButtonType;
exports.validateWalletButtonColor = validateWalletButtonColor;
exports.validateWalletButtonSizeMode = validateWalletButtonSizeMode;
exports.validateWalletButtonLocale = validateWalletButtonLocale;
exports.handleMobilePayStyles = handleMobilePayStyles;
exports.isObjectEmpty = isObjectEmpty;
exports.isOnlyApplePay = isOnlyApplePay;
exports.getTamaraWidget = getTamaraWidget;
exports.getTabbyWidget = getTabbyWidget;
exports.getTalyWidget = getTalyWidget;
exports.preloadFonts = preloadFonts;
exports.getClickToPayHtml = getClickToPayHtml;
exports.isUrl = isUrl;
exports.preloadFonts = preloadFonts;
exports.getValidatedIframeData = getValidatedIframeData;

const applySplitOrder = (documentCheckout) => {
  if (mainConfigService.get('displayMode') !== 'split') return;

  const splitView = documentCheckout.querySelector('.ottu__sdk-split-view');
  if (!splitView) return;

  const splitOrder = mainConfigService.get('splitOrder');
  if (splitOrder && typeof splitOrder === 'object') {
    Object.entries(splitOrder).forEach(([sectionName, order]) => {
      const el = splitView.querySelector(`[data-section="${sectionName}"]`);
      if (el) {
        el.style.order = order;
      }
    });
  }

  if (mainConfigService.get('splitReversed')) {
    splitView.classList.add('ottu__sdk-split-reversed');
  }
};
exports.applySplitOrder = applySplitOrder;

const applyViewToggle = (documentCheckout) => {
  if (mainConfigService.get('displayMode') !== 'split') return;

  const MAX_VISIBLE = 5;

  const splitLeft = documentCheckout.querySelector('.ottu__sdk-split-left');
  if (!splitLeft) return;

  // Clear previous hidden state before recalculating
  splitLeft.querySelectorAll('.ottu__sdk-view-hidden').forEach((el) => {
    el.classList.remove('ottu__sdk-view-hidden');
  });

  // Query all selectable items in DOM order across all lists
  // This respects the actual rendered order (services → cards → methods in split layout)
  const allItemSelector = '.ottu__sdk-accordion-item, .ottu__sdk-installments-loading-block, .ottu__sdk-no-installments-available-block, .ottu__sdk-radio-div';
  const allItems = splitLeft.querySelectorAll(allItemSelector);

  // Hide items beyond MAX_VISIBLE across the global count
  const overflowItems = [];
  allItems.forEach((item, index) => {
    if (index >= MAX_VISIBLE) {
      overflowItems.push(item);
      item.classList.add('ottu__sdk-view-hidden');
      // Hide iframe-placeholder sibling for accordion-type items
      const next = item.nextElementSibling;
      if (next && next.classList.contains('ottu__sdk-iframe-placeholder')) {
        overflowItems.push(next);
        next.classList.add('ottu__sdk-view-hidden');
      }
    }
  });

  // Remove existing toggle button if present (handles re-renders)
  const existing = documentCheckout.querySelector('.ottu__sdk-view-toggle');
  if (existing) existing.remove();

  if (overflowItems.length === 0) return;

  const button = document.createElement('button');
  button.className = 'ottu__sdk-view-toggle ottu__sdk-view-toggle-theme';

  const updateButtonContent = (isExpanded) => {
    const label = isExpanded ? $t('Show less') : $t('Show more');
    const iconClass = 'ottu__sdk-view-toggle-icon' + (isExpanded ? ' ottu__sdk-view-toggle-icon--up' : '');
    button.innerHTML = '<span>' + label + '</span><span class="' + iconClass + '">' + logoSvg.viewToggleArrow + '</span>';
  };

  updateButtonContent(false);

  let expanded = false;
  let animating = false;
  button.addEventListener('click', () => {
    if (animating) return;
    expanded = !expanded;
    updateButtonContent(expanded);

    if (expanded) {
      // Fade in: remove hidden, add reveal animation
      overflowItems.forEach((item) => {
        item.classList.remove('ottu__sdk-view-hidden');
        item.classList.add('ottu__sdk-view-reveal');
      });
      const onRevealEnd = () => {
        overflowItems.forEach((item) => item.classList.remove('ottu__sdk-view-reveal'));
        overflowItems[0].removeEventListener('animationend', onRevealEnd);
      };
      overflowItems[0].addEventListener('animationend', onRevealEnd, { once: true });
    } else {
      // Fade out: play collapse animation, then hide + scroll
      animating = true;
      overflowItems.forEach((item) => {
        item.classList.remove('ottu__sdk-view-reveal');
        item.classList.add('ottu__sdk-view-collapse');
      });
      const onCollapseEnd = () => {
        overflowItems.forEach((item) => {
          item.classList.remove('ottu__sdk-view-collapse');
          item.classList.add('ottu__sdk-view-hidden');
        });
        overflowItems[0].removeEventListener('animationend', onCollapseEnd);
        animating = false;
        if (splitLeft.scrollIntoView) {
          splitLeft.scrollIntoView({ behavior: 'instant', block: 'start' });
        }
      };
      overflowItems[0].addEventListener('animationend', onCollapseEnd, { once: true });
    }
  });

  splitLeft.appendChild(button);
};
exports.applyViewToggle = applyViewToggle;
